export function toggleAttribute(el, attr) {
  el.getAttribute(attr) === 'true' ? el.setAttribute(attr, 'false') : el.setAttribute(attr, 'true');
}

export function toggleFixedBody() {
  document.querySelector('body').classList.toggle('fixed');
}

export function isElementInViewport(el) {
  if (typeof jQuery === 'function' && el instanceof jQuery) {
    el = el[0];
  }

  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function getWindowSize() {
  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height:
      window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
  };
}

export function getDeviceType() {
  const ua = navigator.userAgent;

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) ||
    (ua.includes('Mac') && 'ontouchend' in document)
  ) {
    return 'mobile';
  }
  return 'desktop';
}

export function findOffset(element) {
  let top = 0,
    left = 0;

  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent;
  } while (element);

  return {
    top: top,
    left: left,
  };
}

export function slideToggle(content, button) {
  if (!content.classList.contains('active')) {
    content.classList.add('active');
    content.style.height = 'auto';

    let height = content.clientHeight + 'px';

    content.style.height = '0px';
    if (button) toggleAttribute(button, 'aria-expanded');

    setTimeout(function () {
      content.style.height = height;
      content.style.visibility = 'visible';
    }, 100);
  } else {
    content.style.height = '0px';
    content.style.visibility = 'hidden';

    content.addEventListener(
      'transitionend',
      () => {
        content.classList.remove('active');
        button.setAttribute('aria-expanded', false);
      },
      { once: true }
    );
  }
}

export function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}
